(() => {
  const el = document.querySelector(
    '.tc_video__video[data-sticky=true] video-js, .tc_video__video[data-sticky=true] video',
  );

  let placeholder = null;

  const options = {
    stickyClass: 'tv2-videojs-sticky--fixed',
    placeholderClass: 'tv2-videojs-sticky--placeholder',
  };

  function insertPlaceholder(node, placeholder) {
    if (placeholder === null) {
      placeholder = document.createElement('div');
      placeholder.className = `${node.className} ${options.placeholderClass}`;
      node.parentNode.insertBefore(placeholder, node);
      return placeholder;
    }
  }

  function removePlaceholder(placeholder) {
    if (placeholder !== null) {
      placeholder.parentNode.removeChild(placeholder);
      placeholder = null;
      return placeholder;
    }
  }

  function scrollHandler() {
    const rect = (placeholder || el).getBoundingClientRect();
    const notInView = rect.bottom / rect.height < 0;
    const hasStickyClass = el.classList.contains(options.stickyClass);

    if (notInView && !hasStickyClass) {
      placeholder = insertPlaceholder(el, placeholder);
      el.classList.add(options.stickyClass);
    }

    if (!notInView && hasStickyClass) {
      el.classList.remove(options.stickyClass);
      placeholder = removePlaceholder(placeholder);
    }
  }

  if (el) {
    window.addEventListener('scroll', scrollHandler);
  }
})();
